import { faChevronLeft, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import MyWorkspaceNav from '@/components/MyWorkspaceNav';
import Button from '@/ui/components/Button';
import Heading from '@/ui/components/Heading';

const MyWorkspaceHeader = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="bg-white px-2 py-4 relative text-center">
        <button
          aria-label="Go back"
          className="absolute leading-5 left-2 text-gray-600"
          onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faChevronLeft} size="lg" />
        </button>
        <Heading className="leading-5" text="My Workspace" value={2} />
      </div>

      <div className="flex justify-between items-center">
        {/* The desktop sidebar covers this navigation, so only show the select on narrow views. */}
        <div className="lg:hidden">
          <MyWorkspaceNav />
        </div>

        {location.pathname !== '/people/new' && (
          <div className="ml-auto">
            <Button onClick={() => navigate('/people/new')} size="xs">
              <FontAwesomeIcon icon={faUserPlus} className="mr-1" />
              Create Person
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(MyWorkspaceHeader);
